import { post, get, del } from './requests'

export const getCollaborators = key =>
  get(['api', 'collab'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const listInvitesSent = key =>
  get(['api', 'collab', 'invitesSent'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const listInvitesReceived = key =>
  get(['api', 'collab', 'invitesReceived'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const sendInvite = key => payload =>
  post(
    ['api', 'collab', 'invite'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const acceptInvite = key => payload =>
  post(
    ['api', 'collab', 'accept'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const ignoreInvite = key => payload =>
  post(
    ['api', 'collab', 'ignore'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const deleteInvite = key => payload =>
  post(
    ['api', 'collab', 'removeInvite'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const remindInvite = key => payload =>
  post(
    ['api', 'collab', 'remind'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const removeCollab = key => payload =>
  del(
    ['api', 'collab', 'removeCollab'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const createNote = key => payload =>
  post(
    ['api', 'collab', 'createNote'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const getNotesReceived = key =>
  get(['api', 'collab', 'notesReceived'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const getNotesSent = key =>
  get(['api', 'collab', 'notesSent'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const updateNote = key => payload =>
  post(
    ['api', 'collab', 'updateNote'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const deleteNote = key => payload =>
  del(
    ['api', 'collab', 'deleteNote'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const archiveNote = key => payload =>
  post(
    ['api', 'collab', 'archiveNote'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const readNote = key => payload =>
  post(
    ['api', 'collab', 'readNote'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const closeNote = key => payload =>
  post(
    ['api', 'collab', 'closeNote'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )



// WEBPACK FOOTER //
// ./src/services/collaboration.js